export class MemoPaymentInfoView {
  constructor (
    public memoPaymentId: number,
    public customerId: number
  ) {}
}
